const EARTH_RADIUS_METERS = 6_371_000;

function finiteNumber(...values) {
  for (const value of values) {
    if (value === null || value === undefined || value === "") continue;
    const parsed = Number(String(value).replace(",", "."));
    if (Number.isFinite(parsed)) return parsed;
  }
  return null;
}

function haversineMeters(latFrom, lonFrom, latTo, lonTo) {
  const values = [latFrom, lonFrom, latTo, lonTo].map((value) => finiteNumber(value));
  if (values.some((value) => value === null)) return null;

  const [fromLat, fromLon, toLat, toLon] = values.map((value) => (value * Math.PI) / 180);
  const latDelta = toLat - fromLat;
  const lonDelta = toLon - fromLon;
  const angle =
    2 *
    Math.asin(
      Math.sqrt(
        Math.sin(latDelta / 2) ** 2 +
          Math.cos(fromLat) * Math.cos(toLat) * Math.sin(lonDelta / 2) ** 2
      )
    );
  return angle * EARTH_RADIUS_METERS;
}

export function attendanceDistanceMeters(day, teacher = {}) {
  const directMeters = finiteNumber(
    day?.distanceMeters,
    day?.DistanceMeters,
    day?.distanceFromEstablishmentMeters,
    day?.DistanceFromEstablishmentMeters
  );
  if (directMeters !== null) return directMeters;

  const directKm = finiteNumber(day?.distanceKm, day?.DistanceKm);
  if (directKm !== null) return directKm * 1000;

  const attendanceLat = finiteNumber(
    day?.attLatitude,
    day?.AttLatitude,
    day?.attendanceLatitude,
    day?.latitude
  );
  const attendanceLon = finiteNumber(
    day?.attLongitude,
    day?.AttLongitude,
    day?.attendanceLongitude,
    day?.longitude
  );
  const establishmentLat = finiteNumber(
    day?.estLatitude,
    day?.EstLatitude,
    day?.establishmentLatitude,
    teacher?.estLatitude,
    teacher?.EstLatitude,
    teacher?.establishmentLatitude
  );
  const establishmentLon = finiteNumber(
    day?.estLongitude,
    day?.EstLongitude,
    day?.establishmentLongitude,
    teacher?.estLongitude,
    teacher?.EstLongitude,
    teacher?.establishmentLongitude
  );

  return haversineMeters(establishmentLat, establishmentLon, attendanceLat, attendanceLon);
}

function normalizeTeacherRadius(teacher, radiusMeters) {
  if (!Array.isArray(teacher?.calendar)) return teacher;

  let classifiedPresentDays = 0;
  let inRadiusDays = 0;
  const calendar = teacher.calendar.map((day) => {
    if (!day?.isPresent) return day;

    const distanceMeters = attendanceDistanceMeters(day, teacher);
    if (distanceMeters !== null) {
      const isWithinRadius = distanceMeters <= radiusMeters;
      classifiedPresentDays += 1;
      if (isWithinRadius) inRadiusDays += 1;
      return {
        ...day,
        distanceMeters,
        isWithinRadius,
        isOutsideRadius: !isWithinRadius,
      };
    }

    const serverWithin = day.isWithinRadius === true || day.isWithinRadius === 1;
    const serverOutside = day.isOutsideRadius === true || day.isOutsideRadius === 1;
    if (serverWithin || serverOutside) {
      classifiedPresentDays += 1;
      if (serverWithin) inRadiusDays += 1;
    }
    return day;
  });

  return {
    ...teacher,
    calendar,
    totalDaysPresentInRadius:
      classifiedPresentDays > 0 ? inRadiusDays : teacher.totalDaysPresentInRadius,
  };
}

export function applyRadiusToAttendanceReport(report, radiusValue) {
  const radiusMeters = finiteNumber(radiusValue);
  if (!report || radiusMeters === null || radiusMeters <= 0) return report;

  return {
    ...report,
    radius: radiusMeters,
    teachers: Array.isArray(report.teachers)
      ? report.teachers.map((teacher) => normalizeTeacherRadius(teacher, radiusMeters))
      : report.teachers,
  };
}

